import axios from 'axios'

const API_PATH = 'admins/zalora/orders'

const ZaloraApi = {
  /**
   * Download invoice in PDF format.
   *
   * @param {Number} orderId - Customer::Order::Id
   * @param {String} documentType - zalora document types: [invoice, shippingLabel]
   */
  downloadDocument: async ({
    orderId,
    documentType
  }) => {
    const body     = {
      order_id      : orderId,
      document_type : documentType
    }
    const path     = `${API_PATH}/download_document`
    const response = await axios.post(
      path,
      body,
      { responseType: 'blob' }
    )
    return response
  }
}

export default ZaloraApi